import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 1;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 36 36" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="Style-guide" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="nifty-UI-guide" transform="translate(-756.000000, -2927.000000)" fill={color}>
                <g id="Group-6" transform="translate(713.000000, 2884.000000)">
                    <path d="M63,44.9997073 C63,43.8898926 62.1045695,43 61,43 C59.8877296,43 59,43.8952994 59,44.9997073 L59,59 L44.9997073,59 C43.8898926,59 43,59.8954305 43,61 C43,62.1122704 43.8952994,63 44.9997073,63 L59,63 L59,77.0002927 C59,78.1101074 59.8954305,79 61,79 C62.1122704,79 63,78.1047006 63,77.0002927 L63,63 L77.0002927,63 C78.1101074,63 79,62.1045695 79,61 C79,59.8877296 78.1047006,59 77.0002927,59 L63,59 L63,44.9997073 Z" id="Combined-Shape"></path>
                </g>
            </g>
        </g>
    </svg>
)

export default class IconPlus extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
